import Cookies from "universal-cookie";
import {
  IntegrationSetupStepPathType,
  IntegrationSetupStepType,
} from "../../../config/types";
import { getLoadedRuntimeConfig } from "../../../utils/runtimeConfig";

/**
 *
 * A collection of helper functions from the old pre- files
 *
 */

export const getIsCurrentStepSetScraperStepPath = (
  currentStepSetType: IntegrationSetupStepPathType
) =>
  [
    IntegrationSetupStepPathType.SCRAPER_MFA,
    IntegrationSetupStepPathType.SCRAPER,
    IntegrationSetupStepPathType.SCRAPER_SECURITY_QUESTION,
  ].includes(currentStepSetType);

export const getIsOauthStepType = (stepType: IntegrationSetupStepType | undefined) =>
  stepType === IntegrationSetupStepType.STEP_TYPE_OAUTH ||
  stepType === IntegrationSetupStepType.STEP_TYPE_TRELLO_OAUTH1;

// Apex of the host serving the iframe, so the cookie reaches the tenant's API host.
// Not hardcoded: a page can only set a cookie for a domain it is under. Assumes a
// two-label apex, which every Merge tenant domain is today. A self-hosted Link
// names its domain in config.json instead (e.g. .customer.co.uk, where the last
// two labels would be .co.uk, which browsers refuse).
const getLinkCookieDomain = (): string | undefined => {
  const configured = getLoadedRuntimeConfig()?.cookieDomain;
  if (configured) {
    return configured;
  }
  const hostname = window.location.hostname;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return hostname;
  }
  if (hostname.includes(":") || /^[\d.]+$/.test(hostname)) {
    return undefined;
  }
  const labels = hostname.split(".").filter(Boolean);
  if (labels.length < 2) {
    return undefined;
  }
  return `.${labels.slice(-2).join(".")}`;
};

export const setAgentHandlerLinkCSRFOauthCookie = (cookieVal: string) => {
  // Set Agent Handler Link CSRF Token cookie
  const cookies = new Cookies();
  cookies.set("agenthandlerlink_csrftoken", cookieVal, {
    maxAge: 60 * 5, // 5 minutes
    sameSite: "none", // need this cookie to transfer to the oauth exchange popup
    secure: true,
    path: "/",
    domain: getLinkCookieDomain(),
  });
};

export const setAgentHandlerLinkTestCookie = () => {
  // Set Merge Link oauth test cookie with a static value of "oauth_cookie"
  const cookies = new Cookies();
  cookies.set("agenthandlerlink_oauth_allowed", "oauth_cookie", {
    maxAge: 60 * 1, // 1 minutes
    sameSite: "none", // want to mimic the csrf oauth cookie
    secure: true,
    path: "/",
    domain: getLinkCookieDomain(),
  });
};

export const canNotGetMergeLinkTestCookie = () => {
  // Set Merge Link CSRF Token cookie
  const cookies = new Cookies();
  return cookies.get("agenthandlerlink_oauth_allowed") == null;
};
